import { z } from 'zod';
import { KEY_REGEX } from './fields.js';
export const FIELD_CHECKLIST_KINDS = ['check', 'text', 'number', 'photo', 'signature'];
export const FieldChecklistItemInput = z.object({
    key: z.string().regex(KEY_REGEX).max(63),
    label: z.string().min(1).max(160),
    kind: z.enum(FIELD_CHECKLIST_KINDS).default('check'),
    required: z.boolean().default(false),
});
export const FieldChecklistTemplateInput = z.object({
    id: z.string().uuid().optional(),
    key: z.string().regex(KEY_REGEX).max(63),
    name: z.string().min(1).max(160),
    description: z.string().max(1000).optional(),
    service_ids: z.array(z.string().uuid()).max(100).default([]),
    items: z
        .array(FieldChecklistItemInput)
        .max(50)
        .superRefine((items, ctx) => {
        const keys = new Set();
        items.forEach((item, index) => {
            if (keys.has(item.key)) {
                ctx.addIssue({
                    code: 'custom',
                    path: [index, 'key'],
                    message: 'Checklist item keys must be unique.',
                });
            }
            keys.add(item.key);
        });
    }),
    active: z.boolean().default(true),
});
export const FIELD_WORK_GUIDE = `
FIELD WORK EXECUTION

Use get_field_day to prepare a worker's assigned route, then get_field_job_brief before work starts. Structured actions are assignment-scoped and use the same database command as the phone UI.

- set_field_job_status moves a visit through en_route, in_progress, and done; completion is rejected until required checklist items are complete.
- update_field_checklist records boolean, text, number, photo-document, or signature-document evidence.
- record_field_material and add_field_note retain job costing and customer context.
- record_field_opportunity captures an on-site upsell for office follow-up without silently changing the approved scope.
- save_field_checklist_template customizes required proof globally or for selected catalog services.
`;
//# sourceMappingURL=field-work.js.map